import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';

/** Comentario o nota (llave + texto). */
@Component({
  selector: 'ui-flow-note-node',
  standalone: true,
  imports: [UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui-flow-note">
      <svg class="ui-flow-note__brace" viewBox="0 0 16 96" preserveAspectRatio="none" aria-hidden="true">
        <path
          d="M13 3 C7 3 8 24 8 24 C8 40 3 44 3 48 C3 52 8 56 8 72 C8 72 7 93 13 93"
        />
      </svg>
      <ui-flow-label [text]="label()" tone="muted" />
    </div>
  `,
  styles: `
    :host { display: inline-flex; }
    .ui-flow-note {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      max-width: 200px;
    }
    .ui-flow-note__brace {
      flex: 0 0 auto;
      width: 12px;
      height: 72px;
    }
    .ui-flow-note__brace path {
      fill: none;
      stroke: #cbd5e1;
      stroke-width: 1.5;
      stroke-linecap: round;
    }
  `,
})
export class UiFlowNoteNodeComponent {
  readonly label = input.required<string>();
}
